<!--
 * @Author: LZT
 * @Date: 2024-12-11 11:14:08
 * @LastEditors: ITDLCL
 * @Description:
 * @FilePath: \qs\src\App.vue
-->
<template>
  <router-view v-slot="{ Component }">
    <transition :name="transitionName">
      <div style="width: 100%;height: 100%;" :key="route.fullPath">
        <component :is="Component" />
      </div>
    </transition>
  </router-view>
  <!-- 微信一键授权登录弹窗 -->
  <WxLogin v-if="showWxLogin" :showPopup="showWxLogin" />
  <!-- 屏幕共享弹窗 -->
  <ScreenSharingDialog :showPopup="showScreenSharing" v-if="showScreenSharing" :screenSharingUserName="screenSharingUserName" :screenSharingUserAvatar="screenSharingUserAvatar" />
</template>
<script setup>
import { watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getLocalStorage, isWeixin, parseTime } from "@/utils";
import { setDeviceInfo } from "@/utils/option";
import { getEnvironment } from "@/utils/index";
import useUsersStore from "@/stores/user";
import { useAdhibitionStore } from "@/stores/adhibition";
import WxLogin from "@/components/Login/wxLogin.vue";
import ScreenSharingDialog from "@/components/screenSharingDialog/index.vue";
import loginToWebSocket from "@/utils/webSocket/loginToWebSocket";
const adhibitionStore = useAdhibitionStore();
const usersStore = useUsersStore();
const route = useRoute();
const router = useRouter();

// 路由切换动画方向控制
const transitionName = ref('slide-left');

// 路由栈管理
const routeStack = ref([]);

// 是否是第一次进入系统
const isFirstEntry = ref(true);

// 监听路由变化，判断前进还是后退
router.afterEach((to, from) => {
  // 第一次进入系统，不显示动画
  if (isFirstEntry.value) {
    isFirstEntry.value = false;
    transitionName.value = '';
    routeStack.value = [to.path];
    return;
  }

  // 如果是底部导航栏切换，不使用滑动动画，使用淡入淡出
  const isTabBarRoute = (path) => {
    return ['/home/index', '/stockQuotation/index', '/optional/opt-stock', '/vip/index'].includes(path);
  };

  // 底部导航栏切换使用淡入淡出
  if (isTabBarRoute(to.path) && isTabBarRoute(from.path)) {
    transitionName.value = 'fade';
    // 清空路由栈，因为这是tab切换
    routeStack.value = [to.path];
    return;
  }

  // 获取当前路由在栈中的位置
  const fromIndex = routeStack.value.indexOf(from.path);
  const toIndex = routeStack.value.indexOf(to.path);

  // 如果目标路由在栈中且位置在当前路由之前，说明是后退
  if (toIndex !== -1 && fromIndex !== -1 && toIndex < fromIndex) {
    // 后退：从左向右滑出
    transitionName.value = 'slide-right';
  } else if (toIndex === -1) {
    // 如果目标路由不在栈中，说明是新的前进
    // 前进：从右向左滑入
    transitionName.value = 'slide-left';
    // 将新路由加入栈中
    routeStack.value.push(to.path);
  } else if (fromIndex === -1) {
    // 如果是刷新页面或直接访问，默认使用前进动画
    transitionName.value = 'slide-left';
    // 初始化路由栈
    routeStack.value = [to.path];
  } else {
    // 其他情况默认前进
    transitionName.value = 'slide-left';
  }
});

const showWxLogin = computed(() => {
  return usersStore.loginPopup;
});
const showScreenSharing = computed(() => {
  return usersStore.screenSharingPopup;
});
const screenSharingUserName = computed(() => {
  return usersStore.screenSharingUserName;
});
const screenSharingUserAvatar = computed(() => {
  return usersStore.screenSharingUserAvatar;
});

onMounted(async () => {
  if (!getLocalStorage("deviceId")) {
    setDeviceInfo();
  }
  if (!isWeixin(2)) {
    const date = getLocalStorage("uc_weixin_login_date");
    if (date) {
      const d1 = parseTime(new Date(), "{y}{m}{d}");
      if (d1 - parseInt(date) > 7) {
        localStorage.clear();
      }
    }
  };
  const environment = getEnvironment();
  adhibitionStore.setEnvironment(environment);
  // 获取app 传递的设备状态栏高度
  const urlParams = new URLSearchParams(window.location.search);
  const barHeight = urlParams.get('statusBarHeight');
  usersStore.setNavBarHeight(barHeight);
  // 建立socket连接 同时保活
  loginToWebSocket();
});
</script>

<style>
::-webkit-scrollbar {
  display: none;
}
body {
  height: 100vh;
  width: 100vw;
  /* background: #000000; */
  background: #fff;
  overflow: hidden;
}

/* 页面切换动画 - 从右向左滑入（前进） */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  position: absolute;
  width: 100%;
  height: 100%;
}

.slide-left-enter-from {
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter-to {
  transform: translate3d(0, 0, 0);
}

.slide-left-leave-from {
  transform: translate3d(0, 0, 0);
}

.slide-left-leave-to {
  transform: translate3d(-100%, 0, 0);
}

/* 页面切换动画 - 从左向右滑出（后退） */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  position: absolute;
  width: 100%;
  height: 100%;
}

.slide-right-enter-from {
  transform: translate3d(-100%, 0, 0);
}

.slide-right-enter-to {
  transform: translate3d(0, 0, 0);
}

.slide-right-leave-from {
  transform: translate3d(0, 0, 0);
}

.slide-right-leave-to {
  transform: translate3d(100%, 0, 0);
}

/* 淡入淡出动画（用于底部导航栏切换） */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
